import {
  REQUEST_SPONSOR_LIST,
  REQUEST_SPONSOR
} from './mutation-types'

export default {
  [REQUEST_SPONSOR_LIST](state, receivedData) {
    state.sponsorList = receivedData.content;
    state.sponsorListCount = receivedData.totalElements;
  },
  [REQUEST_SPONSOR](state, receivedData) {
    state.sponsor = receivedData
  },
}